import darkTheme from '@/themes/themes/darkTheme';
import drakkullahTheme from '@/themes/themes/drakkulahTheme';
import sherbetTheme from '@/themes/themes/sherbetTheme';
import Theme from '@/classes/theme/Theme';

const dark = new Theme(darkTheme, true);
const sherbet = new Theme(sherbetTheme, false);
const drakkullah = new Theme(drakkullahTheme, true);

export default {
  [dark.name]: dark,
  [sherbet.name]: sherbet,
  [drakkullah.name]: drakkullah,
};
